import React from 'react';
import { FormattedMessage } from 'react-intl';
import MDMCallOutput from './MDMCallOutput'

export default function AccountInfoTabBody() {

	return (
		<>
		  <div className="form-group col-md-12 text-left">
		  	<h2 class="h3"><FormattedMessage id="sima.account.accountInfo.title" /></h2>
		  </div>
		  <MDMCallOutput />
		</>
	);
}
